import {connect} from "react-redux"
import {IncomingHttpHeaders} from "http"
import State from "../../ducks/state"
import {SupportedRegionTypes} from "../../models/regions"
import {formatCdnPathWithVariant} from "../../utils/getCdnUrl"
import {REALM_HEADER} from "../../config/constants"

export const mapStateToProps = (state: State) => {
    const {icon}: any =
        state.data?.regions.find(region => region.type === SupportedRegionTypes.SecureIcon)?.elements[0] || []
    const realm = (state.request.headers as IncomingHttpHeaders)[REALM_HEADER] as string
    const {variant, iconsVersionPath} = state.settings
    return {
        icon: (icon && formatCdnPathWithVariant(icon as string, realm, variant, iconsVersionPath)) || undefined,
    }
}

export default connect(mapStateToProps)
